import React from 'react';
import bindAll from 'lodash.bindall';
import { Box } from "@chakra-ui/layout";
import IconButton from '../components/icon-button/icon-button.jsx';
import '../monitorDrawer/SegmentedRadio.css';
import bleIcon from './assets/icon--ble.svg';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {injectIntl} from 'react-intl';
import {connect} from 'react-redux';
// import {openConnectionModal} from '../reducers/modals.js';
import classNames from 'classnames';
import {isScratchDesktop} from '../lib/isScratchDesktop.js';
import {isWebview} from '../lib/supported-browser.js';
import { setConnectState, setConnectionMode } from '../store/connect-state'
import { setDisconnectModal } from '../store/modals'
// import VM from 'scratch-vm';

class BleBtn extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, ['handleConnect']);
    }

    componentDidMount () {
    }

    handleConnect () {
        if (!this.props.isConnected) {
            this.props.setConnectionMode('ble');
            window.peripheral.scan('0x303a')
        } else {
            this.props.setDisconnectModal(true)
        }
        // this.props.onShowExtensionAlert('Nous');
        // this.props.setMode('ble');
        // if (this.props.vm.getPeripheralIsConnected('Nous')) {
        //     this.props.onShowExtensionAlert('Nous');
        // } else {
        //     this.props.setModalExtensionId('Nous');
        //     this.props.vm.scanForPeripheral('Nous', '0x303a');
        // }
    }

    render () {
        return (

            <IconButton
                className={
                    !this.props.show ? "bleButton active" : 
                    isScratchDesktop() || isWebview() ? 
                    "bleButton desktop" : "bleButton"
                }
                // className={classNames(styles.bleButton, {
                //     [styles.active]: !this.props.show,
                //     [styles.desktop]: isScratchDesktop() || isWebview()
                // })}
                img={bleIcon}
                onClick={this.handleConnect}
            />

        );
    }
}

BleBtn.propTypes = {
    isConnected: PropTypes.bool,
    show: PropTypes.bool,
    onShowExtensionAlert: PropTypes.func
};

const mapStateToProps = state => ({
    isConnected: state.connectStore.isConnected
});

const mapDispatchToProps = dispatch => ({
    setConnectionMode: mode => {
        dispatch(setConnectionMode(mode));
    },
    setDisconnectModal: state => {
        dispatch(setDisconnectModal(state));
    },
    onShowExtensionAlert: data => {
        // dispatch(setConnectionModalExtensionId(data));
        // dispatch(setConnectionMode(mode));
        // dispatch(openConnectionModal());
    }
});

export default compose(
    injectIntl,
    connect(mapStateToProps, mapDispatchToProps)
)(BleBtn);
